import { render } from "./DowntimesServices.vue?vue&type=template&id=54986c31"
import script from "./DowntimesServices.vue?vue&type=script&lang=js"
export * from "./DowntimesServices.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__